import pxRunner from "@/pixels/runner";
import pixelDb from "@/pixels/pixelDb";
import Vue from "vue";

jest.mock("vue", () => ({
  $log: {
    info: jest.fn(),
    error: jest.fn()
  }
}));

describe("pxRunner", () => {
  beforeEach(() => {
    Vue.$log.info.mockClear();
    Vue.$log.error.mockClear();
  });

  describe("run", () => {
    it("should log error when provider does not exist", () => {
      pxRunner.run("nonExistentProvider.fx", {});
      expect(Vue.$log.error).toHaveBeenCalledWith(
        "Error en definición de trigger, el provider no existe: nonExistentProvider.fx"
      );
    });

    it("should execute function immediately when provider is enabled", () => {
      jest.useFakeTimers();
      const fx = jest.fn();

      pixelDb.providers = {
        existingProvider: {
          enabled: true,
          fx
        }
      };
      pxRunner.run("existingProvider.fx", {});
      expect(setTimeout).toHaveBeenCalledWith(expect.any(Function), 100);
      jest.runAllTimers();
      expect(fx).toHaveBeenCalled();
    });

    it("should queue function when provider is not enabled", () => {
      const fx = jest.fn();
      pixelDb.providers = {
        existingProvider: {
          enabled: false,
          fx
        }
      };
      pxRunner.run("existingProvider.fx", {});
      expect(pixelDb.providers.existingProvider.queue.length).toBe(1);
    });
  });

  describe("enableProvider", () => {
    it("should call callback immediately when provider is already enabled", () => {
      const cb = jest.fn();
      const provider = {
        enabled: true
      };
      pxRunner.enableProvider(provider, cb);
      expect(cb).toHaveBeenCalled();
    });

    it("should call provider.enable when provider is not enabled and does not have a wait function", () => {
      const cb = jest.fn();
      const provider = {
        enabled: false,
        enable: jest.fn()
      };
      pxRunner.enableProvider(provider, cb);
      expect(provider.enable).toHaveBeenCalled();
    });

    it("should not call provider.enable when provider is already loading", () => {
      const cb = jest.fn();
      const provider = {
        enabled: false,
        loading: true,
        enable: jest.fn()
      };
      pxRunner.enableProvider(provider, cb);
      expect(provider.enable).not.toHaveBeenCalled();
    });

    it("should call provider.init when provider.wait returns true", () => {
      const cb = jest.fn();
      const provider = {
        enabled: false,
        wait: jest.fn().mockReturnValue(true),
        init: jest.fn()
      };
      pxRunner.enableProvider(provider, cb);
      expect(provider.init).toHaveBeenCalled();
    });
  });
});